(function () {
  var SECTION_SELECTOR = '[data-lucien-contact-native-form]';
  var STORAGE_KEY = 'lucienContactFormSubmit';
  var STORAGE_TTL = 2 * 60 * 1000;
  var SCROLL_DELAYS = [0, 150, 450, 900];

  function getUrlParams() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (error) {
      return null;
    }
  }

  function clearStoredSubmit() {
    try {
      if (window.sessionStorage) {
        window.sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (error) {
      // Ignore storage errors.
    }
  }

  function readStoredSubmit() {
    var stored;

    try {
      stored = window.sessionStorage && window.sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }

    if (!stored) {
      return null;
    }

    try {
      stored = JSON.parse(stored);
    } catch (error) {
      clearStoredSubmit();
      return null;
    }

    if (!stored || !stored.sectionId || !stored.createdAt || Date.now() - stored.createdAt > STORAGE_TTL) {
      clearStoredSubmit();
      return null;
    }

    return stored;
  }

  function writeStoredSubmit(section) {
    if (!section || !section.dataset.sectionId) {
      return;
    }

    try {
      window.sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          sectionId: section.dataset.sectionId,
          createdAt: Date.now()
        })
      );
    } catch (error) {
      // sessionStorage can be unavailable in strict privacy modes.
    }
  }

  function getHeaderOffset() {
    var header = document.querySelector('[data-lucien-header-bar]')
      || document.querySelector('.lucien-header__bar')
      || document.querySelector('.shopify-section-header-sticky');

    if (!header) {
      return 0;
    }

    return Math.ceil(header.getBoundingClientRect().height || 0);
  }

  function scrollToSection(section) {
    var top;

    if (!section || !section.isConnected) {
      return;
    }

    top = section.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset() - 12;

    window.scrollTo({
      top: Math.max(0, Math.round(top)),
      left: 0,
      behavior: 'auto'
    });
  }

  function scheduleScrollToSection(section) {
    SCROLL_DELAYS.forEach(function (delay) {
      window.setTimeout(function () {
        scrollToSection(section);
      }, delay);
    });
  }

  function cleanSubmitUrl() {
    var url;
    var params = getUrlParams();

    if (!params || (!params.has('contact_posted') && !params.has('contact_form_submitted'))) {
      return;
    }

    try {
      url = new URL(window.location.href);
      url.searchParams.delete('contact_posted');
      url.searchParams.delete('contact_form_submitted');
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    } catch (error) {
      // Leave the URL untouched if the History API is unavailable.
    }
  }

  function ensureStatus(form) {
    var status = form.querySelector('[data-contact-form-status]');
    var firstField = form.querySelector('.lucien-contact-native-form__field');

    if (status) {
      return status;
    }

    status = document.createElement('p');
    status.className = 'lucien-contact-native-form__status';
    status.setAttribute('data-contact-form-status', '');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('tabindex', '-1');

    form.insertBefore(status, firstField || form.firstChild);

    return status;
  }

  function showSuccess(section, form) {
    var status = ensureStatus(form);
    var message = section.dataset.successMessage
      || 'Your message has been sent. We will get back to you as soon as possible.';

    status.textContent = message;
    status.classList.remove('lucien-contact-native-form__status--error');
    status.classList.add('lucien-contact-native-form__status--success');
  }

  function hasSubmitMarker(section) {
    var params = getUrlParams();
    var stored = readStoredSubmit();
    var sectionId = section.dataset.sectionId;

    if (section.querySelector('[data-contact-server-success]')) {
      return true;
    }

    if (params && params.get('contact_form_submitted') === sectionId) {
      return true;
    }

    if (params && params.get('contact_posted') === 'true' && stored && stored.sectionId === sectionId) {
      return true;
    }

    return Boolean(stored && stored.sectionId === sectionId);
  }

  function bindSection(section) {
    var form = section.querySelector('form');

    if (!form || form.dataset.contactFormBound === 'true') {
      return;
    }

    form.dataset.contactFormBound = 'true';

    form.addEventListener('submit', function () {
      writeStoredSubmit(section);
    });

    if (section.querySelector('[data-contact-server-error]')) {
      clearStoredSubmit();
      return;
    }

    if (hasSubmitMarker(section)) {
      showSuccess(section, form);
      clearStoredSubmit();
      cleanSubmitUrl();
      scheduleScrollToSection(section);
    }
  }

  function bindAll(root) {
    if (root.matches && root.matches(SECTION_SELECTOR)) {
      bindSection(root);
    }

    Array.prototype.slice.call(root.querySelectorAll(SECTION_SELECTOR)).forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindAll(document);
    });
  } else {
    bindAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindAll(event.target);
  });
})();
